import {
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  SvgIcon,
  Typography,
  styled,
} from "@mui/material";
import footerSections from "constants/footerSections";
import { APP_DOCS } from "constants/general";
import { API_URL } from "utils/axios.util";
import FooterCompanyInformation from "./FooterCompanyInformation";
import FooterLinkSections from "./FooterLinkSection";
import { useAppSelector } from "store/appHooks";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "constants/routes";
import Lottie from "lottie-react";
import AnimatatedRocket from "assets/rocket-animated.json";
import { Cancel, CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import moment from "moment";

const TopBox = styled(Box)({
  backgroundColor: "#6E8C20",
  padding: "10px 0 0",
  "& .zones": {
    padding: "40px 0 20px",
    borderBottom: "solid 1px #9CB261",

    "& h4": {
      fontSize: 15,
      fontFamily: "Inter",
      fontWeight: "600",
      lineHeight: "19px",
      margin: 0,
      padding: "0 0 10px",
      color: "#FFF",
    },

    "& ul": {
      listStyleType: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",

      "& li": {
        fontSize: 15,
        fontFamily: "Inter",
        fontWeight: "normal",
        lineHeight: "19px",
        margin: 0,
        padding: "10px 0",
        color: "#FFF",
        flex: "1 0 14%",
      },
    },
  },
  "& .footer-section": {
    borderBottom: "solid 1px #9CB261",
    padding: "20px 0",
    "& .footer-main": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
  "& .copyright-section": {
    padding: "20px 0",
    "& .copyright-main": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",

      "& ul": {
        listStyleType: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",

        "& li": {
          fontSize: 13,
          fontFamily: "Inter",
          fontWeight: "normal",
          lineHeight: "16px",
          margin: 0,
          padding: "0px 10px 0 0",
          color: "#FFF",
          cursor: "pointer",
        },
      },
      "& p": {
        fontSize: 13,
        fontFamily: "Inter",
        fontWeight: "normal",
        lineHeight: "16px",
        margin: 0,
        padding: "0px 0",
        color: "#FFF",
      },
      "& .social-connect": {
        display: "flex",
        flexDirection: "row",
        "& div:first-child": {
          marginRight: "20px",
        },
      },
      "& .copy-mobile": {
        display: "none",
      },
    },
  },
  "@media only screen and (min-width: 320px) and (max-width: 768px)": {
    "& .zones": {
      padding: "20px 0",
      "& ul": {
        "& li": {
          fontSize: 13,
          flex: "1 0 50%",
        },
      },
    },
    "& .footer-section": {
      padding: "0px 0",
      "& .footer-main": {
        flexDirection: "column",
        "& .MuiBox-root": {
          padding: 0,
        },
      },
    },
    "& .copyright-section": {
      "& .MuiContainer-root": {
        padding: "0",
      },
      "& .copyright-main": {
        flexDirection: "column",
        alignItems: "flex-start",
        "& ul": {
          padding: "0 16px",
          "& li": {
            fontSize: 13,
          },
        },
        "& p": {
          display: "none",
        },
        "& .social-connect": {
          margin: "10px 0 0",
          padding: "0 16px 10px",
        },
        "& .copy-mobile": {
          borderTop: "solid 1px #9CB261",
          display: "block",
          padding: "10px 16px 0",

          "& p": {
            display: "block",
            fontSize: 13,
          },
        },
      },
    },
  },
});

/**
 * @returns Footer component
 */

const links: any = [
  {
    name: "Salinas, California",
    l: "36.6777~121.6555",
    place_id: "ChIJD7aA-9QjkYARvH1oErv4GIM",
  },
  {
    name: "Fresno, California",
    l: "36.7378~119.7871",
    place_id: "ChIJr8f9WahdlIAR7aT7Fkq06tA",
  },
  {
    name: "Des Moines, Iowa",
    l: "41.5868~93.6250",
    place_id: "ChIJ7xHjGn2s7ocR2yMRYzTQ0IE",
  },
  {
    name: "Wichita, Kansas",
    l: "37.6872~97.3301",
    place_id: "ChIJRY1NV34tbocR1IQvGfrtSUI",
  },
  {
    name: "Modesto, California",
    l: "37.6393~120.9970",
    place_id: "ChIJF9T9KRzPjYAR_fJAdiwU1fI",
  },
  {
    name: "Visalia, California",
    l: "36.3301~119.2966",
    place_id: "ChIJR3lxDO3RlIARUqOmM9m4nQQ",
  },
  {
    name: "Amarillo, Texas",
    l: "35.2220~101.8313",
    place_id: "ChIJZ9g0IetDAYcRsPaXyiqohAQ",
  },
  {
    name: "Yakima, Washington",
    l: "46.6021~120.5059",
    place_id: "ChIJ2WkX4fJ1m1QR-vl_GzE1pH4",
  },
  {
    name: "Texas Panhandle",
    l: "35.3456~101.3804",
    place_id: "ChIJlXCrQYZDAYcReu9PbEGUp2Y",
  },
  {
    name: "Central Valley, California",
    l: "40.1999~122.2011",
    place_id: "ChIJz7F-Raif0lQRGz61R2J-6z8",
  },
  {
    name: "Lancaster, Pennsylvania",
    l: "40.0379~76.3055",
    place_id: "ChIJS5dFEVzpxokRD04KNcF6Qms",
  },
  {
    name: "Grand Forks, North Dakota",
    l: "47.9253~97.0329",
    place_id: "ChIJte8mJmXz11IRK6FRsliLh78",
  },

  // { name: 'Southern States', l: '~' },
  // { name: 'Corn Belt States', l: '~' },
  // { name: 'Pacific Northwest', l: '~' },
  // { name: 'Red River Valley', l: '~' }
];
const Footer = ({ headerFooterHiddenRoutes }: any) => {
  const { authReducer, userReducer }: any = useAppSelector((state) => state);
  const { isLoggedIn, otpVerification } = authReducer;
  const location = useLocation();
  const navigate = useNavigate();
  const [comingSoon, setComingSoon] = useState(false);
  if (
    (!isLoggedIn || otpVerification) &&
    headerFooterHiddenRoutes?.includes(location.pathname)
  ) {
    return null;
  }

  return null;

  return (
    <TopBox>
      <div className="zones">
        <Container>
          <h4>Agricultural Zones</h4>
          <ul>
            {links?.map((link: any, ind: Number) => (
              <li
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate(
                    `${ROUTES.SEARCH_LISTING}?requirement=0&l=${link.l}&place=${link.name}&place_id=${link.place_id}`,
                  );
                }}
                key={String(ind)}
              >
                {link?.name}
              </li>
            ))}
            {/* <li>Salinas, California</li>
            <li>Fresno, California</li>
            <li>Des Moines, Iowa</li>
            <li>Wichita, Kansas</li>
            <li>Modesto, California</li>
            <li>Visalia, California</li>
            <li>Amarillo, Texas</li>
            <li>Yakima, Washington</li>
            <li>Texas Panhandle</li>
            <li>Central Valley, California</li>
            <li>Lancaster, Pennsylvania</li>
            <li>Grand Forks, North Dakota</li>
            <li>Southern States</li>
            <li>Corn Belt States</li>
            <li>Pacific Northwest</li>
            <li>Red River Valley</li>
            <li>Great Plains States</li>
            <li>Midwest States</li>
            <li>Southern States</li>
            <li>Corn Belt States</li>
            <li>Pacific Northwest</li> */}
          </ul>
        </Container>
      </div>
      <div className="footer-section">
        <Container>
          <div className="footer-main">
            <FooterCompanyInformation />
            <Box display="flex" flexWrap="wrap">
              {footerSections.map((s: any, iDx: number) => (
                <FooterLinkSections key={iDx} {...s} />
              ))}
            </Box>
          </div>
        </Container>
      </div>
      <div className="copyright-section">
        <Container>
          <div className="copyright-main">
            <ul>
              <li
                onClick={() =>
                  window.open(`${API_URL}/public/${APP_DOCS.TC}`, "_blank")
                }
              >
                Terms and Conditions
              </li>
              <li>|</li>
              <li
                onClick={() =>
                  window.open(`${API_URL}/public/${APP_DOCS.PP}`, "_blank")
                }
              >
                Privacy Policy
              </li>
            </ul>
            <p>
              © Copyright {moment().format("yyyy")}. Haystacker. All Rights
              Reserved.
            </p>
            <div className="social-connect">
              <div onClick={() => setComingSoon(true)}>
                <img src={require("assets/img/png/play_store_ic.png")} />
              </div>
              <div onClick={() => setComingSoon(true)}>
                <img src={require("assets/img/png/app_store_ic.png")} />
              </div>
            </div>
            <div className="copy-mobile">
              <p>
                © Copyright {moment().format("yyyy")}. Haystacker. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </Container>
      </div>

      <Dialog
        open={comingSoon}
        fullWidth
        maxWidth="xs"
        PaperProps={{ style: { padding: "20px", borderRadius: "20px" } }}
        onClose={() => setComingSoon(false)}
      >
        <DialogTitle>
          <IconButton
            sx={{ position: "absolute", right: 0, top: 0, zIndex: 3 }}
            onClick={() => setComingSoon(false)}
          >
            <SvgIcon sx={{ fontSize: "2rem" }}>
              <CancelOutlined />
            </SvgIcon>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              maxHeight: "500px",
              minHeight: "350px",
            }}
          >
            <Box
              sx={{
                height: 300,
                width: 400,
                position: "absolute",
                top: 0,
              }}
            >
              <Lottie
                animationData={AnimatatedRocket}
                loop={true}
                style={{ flex: 1 }}
              />
            </Box>
            <Typography
              variant="h4"
              fontWeight={600}
              textAlign="center"
              mb="20px"
              sx={{
                mt: {
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                  sm: "100%",
                  xs: "100%",
                },
              }}
            >
              Coming Soon
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </TopBox>
  );
};

export default Footer;
